<template>
  <div id="app">
    <!-- <img src="./assets/img/right.png"> -->
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App'
};
</script>

<style scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  width: 100%;
  height: 100%;
  /* margin-top: 60px; */
}
body,
html {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue